// Import Component hooks before component definitions
import "./component-hooks";
import Vue from "vue";
import "./registerServiceWorker";
import App from "./App.vue";
import router from "./router";
import { store } from "@/store";
import vuetify from "./plugins/vuetify";
import "./plugins/vue-cookies";
import "./validation/rules";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueCookies from "vue-cookies";
import { Buffer } from "buffer";
import process from "process";
import VueI18n from "vue-i18n";

(window as any).Buffer = Buffer;
(window as any).process = process;

Vue.config.productionTip = false;

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.use(VueCookies);
Vue.$cookies.config("7d");

Vue.use(VueI18n);

import en from "@/i18n/en.json";
import pl from "@/i18n/pl.json";

const messages = {
  en,
  pl,
};

/**
 * Determines the initial locale for the application.
 * - Checks the browser's preferred language (`navigator.language`).
 * @returns The determined locale string ('en' or 'pl').
 */
function getInitialLocale(): string {
  const browserLanguage = navigator.language.split("-")[0]; // e.g., 'en-US' -> 'en'
  // Check if we support the browser's language
  if (messages[browserLanguage]) {
    return browserLanguage;
  }
  return "en";
}

const initialLocale = getInitialLocale();

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: "en",
  messages,
});
// --------------------------------------------------------

// Disable for now as unused
// const socket = io(apiUrl, {
//   path: "/api/v1/ws/socket.io/"
// });
// Vue.use(VueSocketIOExt, socket);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
